import { path } from 'ramda'

import { api } from 'app/api'
import { GET_SEND_FILE } from 'app/common/api/requests/reports/send_file'
import { GET_REPORTS_STATUS } from 'app/common/api/requests/reports/status'
import { popup } from 'app/common/actions/popup'


export const handleSendFileToEmail = async (reportID: number, email: string) => {
  const res = await api.request(GET_SEND_FILE, {
    error: `Не удалось послать файл отчета на email (${reportID})`,
    params: {
      report_id: reportID,
      email,
    },
  })

  const dispatch = path(['store', 'dispatch'], api) as ((a: any) => void) | undefined

  if (res && dispatch) {
    dispatch(popup(`Файл успешно отправлен на почту: ${email}`))
  }
}

// export const createHandleDownloadFile = (fileName: string) => async (reportID: number) => {
//   await reportDownloadFile.download(`${fileName}_${reportID}`, { reportID: String(reportID) })
// }

export const handleCheckStatus = async (reportID: number) => {
  const res: number | null = await api.request(GET_REPORTS_STATUS, {
    error: `Не удалось получить статус генерации отчета (${reportID})`,
    params: {
      report_id: reportID,
    },
  })

  return res
}
